module.exports = __webpack_public_path__ + "a0ee5faa71b303d1044daac402650659.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/buyer-with-color.svg
// module id = 3634
// module chunks = 6